import React, { useState } from "react";
import styles from "./Control.module.sass";
import cn from "classnames";
import Icon from "../../../../components/Icon";
import Actions from "../../../../components/Actions";
import { deleteBanner } from "../../../../Firebase/firebaseDatabase";
import { Link } from "react-router-dom";

const Control = ({ className, visibleActions, up, setVisibleActions, data, setIsActionComplete, setIsClicked }) => {

  const delete_actions = [
    {
      title: "Yes",
      icon: "check",
      action: () => {
        setIsClicked(true);
        deleteBanner(data.id).then(res => {
          if (res === true) {
            setIsActionComplete(true)
            setIsClicked(false)
          }
        })
      },
    },
    {
      title: "No",
      icon: "close",
      action: () => {
        // setVisibleActions(false)
      },
    }
  ]

  return (
    <div className={styles.controlContainer}>
      <div className={cn(styles.control, className)}>
        <Link to={{
          pathname: `/banners/edit/${data.id}`,
          state: { data: data }
        }} style={{
          // width: '35px',
          // marginRight: "20px"
        }}>
          <button className={styles.button}>
            <Icon name="edit" size="20" />
          </button>
        </Link>
      </div>

      <div className={cn(styles.control, className)}>
        <Actions
          className={styles.actions}
          classActionsHead={styles.actionsHead}
          classActionsBody={styles.actionsBody}
          classActionsOption={styles.actionsOption}
          icon="trash"
          items={delete_actions}
          data={data}
          visible={visibleActions}
          setVisible={setVisibleActions}
          up={true}
        />
      </div>
    </div>
  );
};

export default Control;
